import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySum',
  standalone: false,
})
export class ArraySumPipe implements PipeTransform {
  transform<T extends Record<string, number>>(
    items: T[],
    attr: keyof T & string
  ): number {
    return items.reduce((a, b) => a + b[attr], 0);
  }
}
